import { render } from "./Contacto.vue?vue&type=template&id=65270e68&scoped=true"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import "./Contacto.vue?vue&type=style&index=0&id=65270e68&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65270e68"]])

export default __exports__